<template>
  <div class="md-layout">
    <md-card>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <p>{{ $t("extended_exportation.transcript_title") }}</p>
          </div>
          <div class="md-layout-item md-size-30">
            <md-field>
              <label>Template</label>
              <md-select
                id="template"
                v-model="template"
                name="template"
                required
              >
                <md-option value="elementary school"
                  >Elementary school
                </md-option>
                <md-option value="middle school">Middle school</md-option>
                <md-option value="high school">High school</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-size-30">
            <md-field>
              <label>{{ $t("common.program") }}</label>
              <md-select
                id="programs"
                v-model="programSelected"
                :disabled="!template"
                multiple
                name="programs"
                required
              >
                <md-option
                  v-for="(program, index) in programs"
                  :key="program.name + index"
                  :value="program.id"
                  >{{ program.name }}
                </md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-size-30">
            <md-field>
              <label>{{ $t("common.grade") }}</label>
              <md-select id="grade" v-model="gradeSelected" name="grade">
                <md-option
                  v-for="(grade, index) in gradeList"
                  :key="`${index} - ${grade.name}`"
                  :value="grade.name"
                  >{{ grade.name }}
                </md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <div v-if="programSelected.length" class="m-auto">
      <md-button class="md-warning md-round" @click="exportPDF()">
        {{ $t("communication.send_email") }}
      </md-button>
    </div>
  </div>
</template>
<script>
import { service_paths } from "@/constants/Services";
import { Message } from "@/helpers/utils";

export default {
  data() {
    return {
      template: "",
      programSelected: [],
      programs: [],
      gradeSelected: "",
      gradeList: []
    };
  },
  watch: {
    template(newValue) {
      if (newValue) {
        this.programs = [];
        this.programSelected = [];
        this.getProgram();
      }
    }
  },
  methods: {
    getProgram() {
      this.$axios
        .get(service_paths.programs, {
          transcript_template: this.template,
          limit: 99
        })
        .then(response => {
          this.programs = response.data?.data;
        });
    },
    getGrades() {
      this.$axios.get(service_paths.grades, { limit: 99 }).then(response => {
        if (response.data.data) {
          this.gradeList = response.data.data;
        }
      });
    },
    exportPDF() {
      const param = {
        template: this.template,
        program_ids: this.programSelected,
        grade_name: this.gradeSelected
      };
      this.$axios
        .get(`${service_paths.export}/transcript/pdf/student`, param)
        .then(res => {
          if (res.status === 200) {
            Message.success(
              this.$t("extended_exportation.export_file_successfully")
            );
          }
        });
    }
  },
  created() {
    this.getGrades();
  }
};
</script>
